import axios from "axios"
import createSpinner from "../lib/create-spinner"

const tabContainer = document.getElementById('user-resources-content')
if (tabContainer) {
    async function loadTabData(url, targetDiv) {
        targetDiv.innerHTML = ''
        targetDiv.appendChild(createSpinner())
        const response = await axios.get(url)
        targetDiv.innerHTML = response.data
        targetDiv.querySelectorAll('a.page-link').forEach(link => {
            link.addEventListener('click', async e => {
                e.preventDefault()
                loadTabData(link.getAttribute('href'), targetDiv)
            })
        })
    }

    tabContainer.querySelectorAll('div.tab-pane').forEach(async tab => {
        loadTabData(tab.dataset.url, tab)
    })
}
